/* eslint-disable prettier/prettier */
import { type FC } from 'react';
import { useParams } from 'wouter';
import { type z, type ZodObject, type ZodRawShape } from 'zod';

const withParams = <
  P extends ZodRawShape,
  T extends ZodObject<P>,
  U extends {},
>(Component: FC<U & z.infer<T>>, paramsSchema: T) => {
  return (props: U) => {
    const { data: params, success } = paramsSchema.safeParse(useParams());
    if (!success) {
      return null;
    }

    return (
      <Component
        {...params}
        {...props}
      />
    );
  };
};

export default withParams;
